import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import companiesTransactionsService from "services/companiesTransactions";

const initialState = {
  companiesTransactionsList: {
    items: 0,
    totalCount: 0,
    queryParams: {},
  },
  getCompaniesTransactionsList: {
    status: "idle",
    error: false,
  },

  companiesTransactionsReview: {
    items: 0,
    totalCount: 0,
    queryParams: {},
  },
  getCompaniesTransactionsReview: {
    status: "idle",
    error: false,
  },

  companiesTransactionsSignature: {
    items: 0,
    totalCount: 0,
    queryParams: {},
  },
  getCompaniesTransactionsSignature: {
    status: "idle",
    error: false,
  },

  companiesTransactionsCorrections: {
    items: 0,
    totalCount: 0,
    queryParams: {},
  },
  getCompaniesTransactionsCorrections: {
    status: "idle",
    error: false,
  },
};

export const getCompaniesTransactionsListAsync = createAsyncThunk(
  "getCompaniesTransactionsListAsync",
  async ({ queryParams } = {}, thunkAPI) => {
    try {
      const res = await companiesTransactionsService.list(queryParams);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message || "Unknown error"
      );
    }
  }
);

export const getCompaniesTransactionsReviewAsync = createAsyncThunk(
  "getCompaniesTransactionsReviewAsync",
  async ({ queryParams } = {}, thunkAPI) => {
    try {
      const res = await companiesTransactionsService.review(queryParams);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message || "Unknown error"
      );
    }
  }
);

export const getCompaniesTransactionsSignatureAsync = createAsyncThunk(
  "getCompaniesTransactionsSignatureAsync",
  async ({ queryParams } = {}, thunkAPI) => {
    try {
      const res = await companiesTransactionsService.signature(queryParams);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message || "Unknown error"
      );
    }
  }
);

export const getCompaniesTransactionsCorrectionsAsync = createAsyncThunk(
  "getCompaniesTransactionsCorrectionsAsync",
  async ({ queryParams } = {}, thunkAPI) => {
    try {
      const res = await companiesTransactionsService.corrections(queryParams);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message || "Unknown error"
      );
    }
  }
);

const companiesTransactionsSlice = createSlice({
  name: "companiesTransactions",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompaniesTransactionsListAsync.pending, (state, action) => {
        state.getCompaniesTransactionsList.status = "loading";
        state.getCompaniesTransactionsList.error = false;
        state.companiesTransactionsList.queryParams = action.meta.arg;
      })
      .addCase(getCompaniesTransactionsListAsync.fulfilled, (state, action) => {
        state.getCompaniesTransactionsList.status = "idle";
        state.getCompaniesTransactionsList.error = false;
        state.companiesTransactionsList = action.payload;
      })
      .addCase(getCompaniesTransactionsListAsync.rejected, (state, action) => {
        state.getCompaniesTransactionsList.status = "failed";
        state.getCompaniesTransactionsList.error =
          action?.payload || "Failed to fetch companies-transactions list";
      })

      .addCase(getCompaniesTransactionsReviewAsync.pending, (state, action) => {
        state.getCompaniesTransactionsReview.status = "loading";
        state.getCompaniesTransactionsReview.error = false;
        state.companiesTransactionsReview.queryParams = action.meta.arg;
      })
      .addCase(
        getCompaniesTransactionsReviewAsync.fulfilled,
        (state, action) => {
          state.getCompaniesTransactionsReview.status = "idle";
          state.getCompaniesTransactionsReview.error = false;
          state.companiesTransactionsReview = action.payload;
        }
      )
      .addCase(
        getCompaniesTransactionsReviewAsync.rejected,
        (state, action) => {
          state.getCompaniesTransactionsReview.status = "failed";
          state.getCompaniesTransactionsReview.error =
            action?.payload || "Failed to fetch companies-transactions review";
        }
      )

      .addCase(
        getCompaniesTransactionsSignatureAsync.pending,
        (state, action) => {
          state.getCompaniesTransactionsSignature.status = "loading";
          state.getCompaniesTransactionsSignature.error = false;
          state.companiesTransactionsSignature.queryParams = action.meta.arg;
        }
      )
      .addCase(
        getCompaniesTransactionsSignatureAsync.fulfilled,
        (state, action) => {
          state.getCompaniesTransactionsSignature.status = "idle";
          state.getCompaniesTransactionsSignature.error = false;
          state.companiesTransactionsSignature = action.payload;
        }
      )
      .addCase(
        getCompaniesTransactionsSignatureAsync.rejected,
        (state, action) => {
          state.getCompaniesTransactionsSignature.status = "failed";
          state.getCompaniesTransactionsSignature.error =
            action?.payload ||
            "Failed to fetch companies-transactions signature";
        }
      )

      .addCase(
        getCompaniesTransactionsCorrectionsAsync.pending,
        (state, action) => {
          state.getCompaniesTransactionsCorrections.status = "loading";
          state.getCompaniesTransactionsCorrections.error = false;
          state.companiesTransactionsCorrections.queryParams = action.meta.arg;
        }
      )
      .addCase(
        getCompaniesTransactionsCorrectionsAsync.fulfilled,
        (state, action) => {
          state.getCompaniesTransactionsCorrections.status = "idle";
          state.getCompaniesTransactionsCorrections.error = false;
          state.companiesTransactionsCorrections = action.payload;
        }
      )
      .addCase(
        getCompaniesTransactionsCorrectionsAsync.rejected,
        (state, action) => {
          state.getCompaniesTransactionsCorrections.status = "failed";
          state.getCompaniesTransactionsCorrections.error =
            action?.payload ||
            "Failed to fetch companies-transactions corrections";
        }
      );
  },
});

export const { reset } = companiesTransactionsSlice.actions;
export default companiesTransactionsSlice.reducer;
